import { Dimensions, Image, ScrollView, StyleSheet, Text, TouchableOpacity, View } from 'react-native'
import theme from '../../../theme'
import { colorButtonTextEnabled } from '../../../themeConstants'
import { isAndroid } from '../../utils/platformUtils'

const { width } = Dimensions.get('window')

const styles = StyleSheet.create({
    block_content: {
        opacity: 0.5,
    },
    overlay: {
        ...StyleSheet.absoluteFillObject,
        backgroundColor: 'rgba(249, 246, 246, 0.71)', // Gris semi-transparente
        zIndex: 1,
    },
    invisibleContainer: {
        flex: 1,
        flexDirection: 'column',
        position: 'absolute',
        padding: 0,
        bottom: 0,
        width: width,
        justifyContent: 'center',
    },
    progressContainer: {
        flexDirection: 'column',
        marginVertical: 30,
        marginHorizontal: 15,
    },
    containerNextModule: {
        flexDirection: 'row',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center',
    },
    containerImageNextModule: {
        //marginTop: isAndroid() ? -10 : -10,
        width: isAndroid() ? 40 : 40,
        aspectRatio: 1,
        marginRight: 10,
        marginLeft: 10,
        alignItems: 'center',
        alignSelf: 'center',
        zIndex: 2,
    },
    containerImageEvaluate: {
        marginTop: isAndroid() ? -30 : -30,
        width: isAndroid() ? 120 : 150,
        aspectRatio: 1,
        marginRight: 20,
        marginLeft: 10,
        alignItems: 'center',
        zIndex: 2,
    },
    newImageNextModule: {
        width: isAndroid() ? 40 : 40,
        flex: 1,
        borderRadius: 5,
        aspectRatio: 1,
        zIndex: 2,
    },
    newImageEvaluateModule: {
        top: 0,
        left: -5,
        width: isAndroid() ? 120 : 150,
        flex: 1,
        borderRadius: 20,
        aspectRatio: 1,
        zIndex: 2,
    },
    floatModule: {
        flexDirection: 'column',
        position: 'absolute',
        padding: 0,
        bottom: 0,
        width: width,
        alignItems: 'flex-end',
    },
    container: {
        flex: 1,
        backgroundColor: 'white',
        flexDirection: 'column',
    },
    containerAlert: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        backgroundColor: theme.colors.colorPrimary,
        marginTop: 25,
        marginLeft: 0,
        //paddingTop: 10,
        paddingBottom: isAndroid() ? 10 : 20,
        zIndex: 1,
    },
    feedbackAssetContainer: {
        //marginTop: isAndroid() ? -10 : -10,
        width: 40,
        aspectRatio: 1,
        marginRight: 12,
        marginLeft: 12,
        marginTop: 12,
        alignSelf: 'center',
        zIndex: 2,
    },
    feedbackAsset: {
        width: isAndroid() ? 40 : 40,
        flex: 1,
        borderRadius: 5,
        aspectRatio: 1,
        zIndex: 2,
    },
    blockHeader: {
        flexDirection: 'row',
        paddingVertical: 10,
        paddingHorizontal: 12,
    },
    imageHeader: {
        width: 120,
        aspectRatio: 1,
        marginRight: 15,
        borderRadius: 12,
    },
    courseName: {
        fontSize: 22,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
    },
    courseDescription: {
        fontSize: 15,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        marginBottom: 15,
        marginTop: 5,
        marginHorizontal: 12,
    },
    courseDescriptionBig: {
        fontSize: 16,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        marginBottom: 15,
        marginTop: 12,
    },
    seeMoreText: {
        fontSize: 14,
        fontWeight: 'bold',
        color: theme.colors.textSecondary,
        textAlign: 'right',
        marginHorizontal: 12,
        position: 'relative',
        top: -15,
    },
    levelKnowledgeBlock: {
        flex: 1,
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
        marginHorizontal: 0,
        paddingTop: 10,
        paddingHorizontal: 10,
        paddingBottom: isAndroid() ? 10 : 25,
        zIndex: 1,
    },
    levelKnowledgeBlock2: {
        flex: 1,
        justifyContent: 'flex-end',
        alignItems: 'flex-start',
        marginHorizontal: 0,
        marginTop: 0,
        paddingHorizontal: 10,
        //paddingBottom: isAndroid() ? 10 : 25,
        zIndex: 1,
    },
    nextContent: {
        fontSize: 13,
        fontWeight: 'regular',
        color: 'white',
        textAlign: 'right',
    },
    levelKnowledgeAsset: {
        alignContent: 'flex-start',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
    },
    levelKnowledgeTitle: {
        fontSize: 16,
        fontWeight: 'bold',
        color: 'white',
        textAlign: 'left',
        marginBottom: 10,
    },
    levelKnowledgeDescription: {
        fontSize: 16,
        fontWeight: 'normal',
        textAlign: 'left',
        color: theme.colors.textPrimary,
        paddingRight: 80,
    },
    areaRactions: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: 10,
        borderColor: theme.colors.lightGray,
        borderWidth: 1.0,
        borderRadius: 10,
    },
    buttomLike: {
        flexDirection: 'row',
        borderRadius: 5,
        paddingHorizontal: 10,
        justifyContent: 'center',
        alignItems: 'center',
    },
    imageButtomLike: {
        width: 20,
        marginRight: 5,
    },
    likes: {
        fontSize: 14,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
    },
    dividerVerticalLine: {
        borderLeftWidth: 1,
        borderLeftColor: theme.colors.lightGray,
        height: '100%',
    },
    dividerHorizontalLine: {
        borderBottomWidth: 0.2,
        borderBottomColor: theme.colors.lightGray,
        width: '100%',
    },
    buttomIntelli: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 10,
        height: 40,
        backgroundColor: theme.colors.colorPrimary,
        padding: 10,
        flex: 1,
    },
    textButtom: {
        fontSize: 15,
        fontWeight: 'bold',
        color: 'white',
    },
    containerButtonLine: {
        flexDirection: 'row',
        paddingHorizontal: 10,
        paddingBottom: 10,
    },
    containerReactions: {
        flexDirection: 'row',
        padding: 5,
        alignItems: 'center',
    },
    buttonLine: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        alignContent: 'center',
        borderRadius: 5,
        height: 40,
        width: '100%',
        backgroundColor: theme.colors.colorPrimary,
        paddingVertical: 5,
        paddingHorizontal: 15,
    },
    textButtonLine: {
        fontSize: 14,
        textTransform: 'uppercase',
        fontWeight: 'bold',
        color: colorButtonTextEnabled,
    },
    imageModuleList: {
        width: 60,
        aspectRatio: 1,
        marginRight: 14,
        borderRadius: 10,
        overflow: 'hidden',
    },
    imageTypeModuleList: {
        width: 18,
        height: 18,
        aspectRatio: 1,
        marginLeft: 10,
    },
    containerModuleList: {
        flex: 1,
        marginRight: 10,
    },
    containerTitleModuleList: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    titleModuleList: {
        fontSize: 15,
        fontWeight: 'bold',
        marginBottom: 5,
        color: theme.colors.textPrimary,
    },
    descriptionModuleList: {
        fontSize: 15,
        color: theme.colors.textSecondary,
        fontWeight: 'normal',
        marginBottom: 10,
        paddingRight: 10,
    },
    descriptionModuleListBig: {
        fontSize: 17,
        color: theme.colors.textSecondary,
        fontWeight: 'normal',
        marginBottom: 10,
        paddingRight: 10,
    },
    containerStatusModuleList: {
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    statusModuleList: {
        justifyContent: 'center',
        alignContent: 'center',
        paddingHorizontal: 10,
        paddingVertical: 3,
        borderRadius: 5,
        borderWidth: 2,
        alignSelf: 'flex-start',
    },
    statusModuleText: {
        fontSize: 12,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    percentageModuleText: {
        fontWeight: '700',
    },
    titleCourseInModule: {
        fontSize: 12,
        fontWeight: 'bold',
        color: theme.colors.darkGray,
    },
    imageModule: {
        width: 20,
        aspectRatio: 1,
        backgroundColor: '#fafafa',
        marginRight: 5,
        borderRadius: 5,
        borderColor: theme.colors.lightGray,
        borderWidth: 0.2,
    },
    containerDescription: {
        flex: 1,
        marginTop: 12,
        marginBottom: 0,
        paddingHorizontal: 12,
    },
    descriptionModule: {
        fontSize: 15,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
    },
    descriptionModuleBig: {
        fontSize: 20,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
    },
    blockList: {
        flexDirection: 'row',
        paddingHorizontal: 0,
        paddingBottom: 15,
        paddingTop: 10,
        //backgroundColor: theme.colors.modalBackground,
        borderRadius: 5,
        marginHorizontal: 10,
    },
    containerModule: {
        flex: 1,
        backgroundColor: 'white',
        flexDirection: 'column',
    },
    titleModule: {
        fontSize: 22,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        paddingHorizontal: 10,
    },
    courseNameModule: {
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: 10,
    },
    containerCloudCheck: {
        width: 36,
        height: 36,
        borderRadius: 16,
        backgroundColor: theme.colors.formsBackground,
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft: 12,
    },
    floatModule: {
        flexDirection: 'column',
        position: 'absolute',
        padding: 0,
        bottom: 0,
        width: width,
        alignItems: 'flex-end',
    },
    imageNextModule: {
        position: 'absolute',
        bottom: 0,
        right: 15,
        width: 100,
        height: 100,
        aspectRatio: 1,
        borderRadius: 10,
        justifyContent: 'flex-end',
        zIndex: 2,
    },
    nextContentBlock: {
        flex: 1,
        backgroundColor: '#AAC0DE',
        padding: 10,
        justifyContent: 'center',
        alignItems: 'center',
    },
    nextContentText: {
        fontSize: 11,
        color: theme.colors.colorPrimary,
        fontWeight: 'normal',
    },
    nextContentInfoBlock: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: 15,
        paddingTop: 5,
        paddingBottom: 35,
        backgroundColor: theme.colors.modalBackground,
        borderWidth: 0,
        borderRadius: 0,
    },
    titleNextModule: {
        flex: 1,
        fontSize: 16,
        fontWeight: 'bold',
        color: 'white',
        textAlign: 'left',
        marginTop: 10,
        marginRight: 0,
    },
    textDescription: {
        fontSize: 14,
        fontWeight: 'normal',
        color: theme.colors.colorPrimary,
        color: 'white',
        //marginHorizontal: 15,
        //marginTop: 5,
        //marginBottom: 15,
    },
    titleNextModuleBis: {
        flex: 1,
        fontSize: 14,
        fontWeight: 'bold',
        color: 'white',
        textAlign: 'right',
    },
    descriptionNextModule: {
        fontSize: 15,
        fontWeight: 'normal',
        color: 'white',
        textAlign: 'right',
        marginRight: 15,
        marginBottom: 5,
    },
    nextContentDetailBlock: {
        flex: 1,
        flexDirection: 'row',
        alignContent: 'center',
        justifyContent: 'flex-end',
    },
    buttonContainer: {
        flexDirection: 'column',
        position: 'absolute',
        padding: 15,
        bottom: 15,
        width: width,
    },
    mainButton: {
        flexDirection: 'row',
        marginTop: 10,
        marginRight: 10,
        backgroundColor: 'white',
        paddingHorizontal: 5,
        paddingVertical: 10,
        borderRadius: 10,
        alignItems: 'center',
        justifyContent: 'center',
    },
    mainButtonText: {
        fontSize: 16,
        color: theme.colors.colorPrimary,
        fontWeight: 'bold',
        textAlign: 'right',
        paddingLeft: 15,
    },
    iconButton: {
        marginLeft: 15,
        marginRight: 5,
    },
    iconNextContent: {
        marginRight: 12,
        marginBottom: 0,
        alignSelf: 'center',
    },
    mainButtonTextNextContent: {
        color: theme.colors.colorPrimary,
        fontWeight: 'bold',
        textAlign: 'right',
    },
    borderButton: {
        marginTop: 10,
        backgroundColor: 'white',
        borderWidth: 2,
        borderColor: theme.colors.colorPrimary,
        padding: 10,
        borderRadius: 10,
    },
    borderButtonText: {
        color: theme.colors.textPrimary,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    containerTextIcon: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    approvalRate: {
        fontSize: 14,
        fontWeight: 'bold',
        color: theme.colors.colorApproved,
        paddingHorizontal: 10,
    },
    marginStart: {
        marginStart: 10,
    },
    marginLeft: {
        marginLeft: 10,
    },
    spacer: {
        height: 160,
    },
    progressBar: {
        borderRadius: 0,
        marginBottom: isAndroid() ? 0 : 30,
        borderColor: 'transparent',
    },
    containerOffline: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        borderColor: theme.colors.lightGray,
        borderWidth: 1.0,
        borderRadius: 10,
        paddingVertical: 4,
        paddingHorizontal: 12,
        marginTop: 6,
        maxWidth: '82%',
    },
    flexDirectionRow: {
        flexDirection: 'row',
    },
    spacer: {
        height: 4,
    },
    spacer1: {
        height: 12,
    },
    spacer2: {
        height: 100,
    },
})

export default styles
